import '@vtmn/icons/dist/vitamix/font/vitamix.css';
import '@itrh/lib-itrh/dist/bundle.css';
import './app.css';
import App from './app/App.svelte';
import './utility-services/Translation.service';
import { mount } from 'svelte';

const app = mount(App, {
	target: document.body
});

export default app;
